import React from 'react';
import root from 'window-or-global';
import {withRouter} from 'react-router';
import PropTypes from 'prop-types';
import EpicGamesFooter from 'epic-games-footer/app/scripts/EpicGamesFooter';
import Immutable from 'seamless-immutable';
import {generateRoutePath} from 'epic-common/src/route';

class EpicGamesFooterWrapper extends React.PureComponent {
    static propTypes = {
        loginStore: PropTypes.object,
        history: PropTypes.object.isRequired,
        footerStore: PropTypes.object,
        localizationStore: PropTypes.object
    };

    /**
     * Routes to link's href
     * @param {Object} link
     */
    addOnClick(link, history) {
        if (link && link.href) {
            link.onClick = (e) => {
                e.preventDefault();
                e.stopPropagation();
                //Open page directly when click external link
                if (link.href.indexOf('/') === 0) {
                    history.push(generateRoutePath(link.href));
                } else {
                    root.location = link.href;
                }
            };
        }
        return Immutable(link);
    }

    /**
     * Prepares the array of links for the footer
     * @param {array} links
     */
    setLinks(links) {
        const {history} = this.props;
        links.forEach((link) => {
            this.addOnClick(link, history);
        });
        return Immutable(links);
    }

    render() {
        const loginStore = this.props.loginStore || {};
        const config = this.props.footerStore.config ? this.props.footerStore.config.asMutable({deep: true}) : {};
        const epicPropertyName = config.epicPropertyName || 'battle_breakers';
        const links = this.setLinks(config.links || []);
        const accountInfo = this.props.loginStore ? this.props.loginStore.accountInfo || {} : {};
        const email = accountInfo.email || '';
        const localizationStore = this.props.localizationStore || {};
        const msg = localizationStore.messages || {};

        return (
            <div id="footerSection" className="section fp-auto-height">
                <EpicGamesFooter
                    epicPropertyName={epicPropertyName}
                    isLoggedIn={loginStore.isLoggedIn}
                    links={links}
                    socialLinks={config.socialLinks || []}
                    copyrights={config.copyrights || []}
                    legalTags={config.legalTags || []}
                    logos={config.logos || []}
                    newLineCopyrights={config.newLineCopyrights}
                    newsLetterConfigs={config.newsLetterConfigs || {}}
                    enableNewsLetter={config.enableNewsLetter || false}
                    i18n={msg}
                    email={email} />
            </div>
        );
    }
}

export default withRouter(EpicGamesFooterWrapper);
